import React, { useState, useContext, useEffect, useCallback, useRef} from "react";

//import DatePicker from "react-bootstrap-date-picker";
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { postData } from "../services/guestService";
import { useLocation } from "react-router-dom";
import { CarrierContext } from "../contexts/CarrierContext";

import Footer from "./Footer";
import BackToTopButton from "./BackToTop";
import { getAPIData } from "../services/guestService";
import { v4 as uuidv4 } from "uuid";

//import { ToastContext } from "../contexts/ToastContext";
import PaymentMethodTab from "./PaymentMethodTab";
//import Toast from "./Toast";
import { LanguageContext } from "../contexts/LanguageContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderPayment from "./HeaderPayment";
import Breadcrumbs from "./Breadcrumbs";
import { LogContext } from "../contexts/LogContext";
//import Header from "./Header";

//import {getToken} from "./pciTokenizer";

//import { formData } from "../services/tokenService";

export default function MakePayment() {
  const location = useLocation();
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;
  const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();

  /*const { showToast, setShowToast, toastMessage, toastType, triggerToast } =
    useContext(ToastContext);*/
  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const [cms, setPaymentCMS] = useState("");

  const { Log } = useContext(LogContext);

  let defaultDate = new Date();
  defaultDate.setDate(defaultDate.getDate());
  const [date] = useState(defaultDate);

  const [userdata, setUserData] = useState("");
  const [user, setUser] = useState("");

  const [showTotalAmt, setShowtotalAmt] = useState(true);
  const [showOtherAmt, setShowOtherAmt] = useState(false);

  const [caseId, setCaseId] = useState("");
  const [subscriberName, setSubscriberName] = useState("");
  const [totalAmountDue, setTotalAmountDue] = useState("");
  const [paymentConfig, setPaymentConfig] = useState([]);
  const [paymentAmtThreshold, setPaymentAmtThreshold] = useState([]);
  const [payOtherAmount, setPayOtherAmount] = useState("");
  const [payOtherAmtErr, setPayOtherAmtErr] = useState("");
  const [totalAmtDueErr, setTotalAmtDueErr] = useState("");
  const [notifyErr, setNotifyErr] = useState("");
  const [notifySuccess, setNotifySuccess] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [cim, setCim] = useState("");
  const [langSelected, setLangSelected] = useState(
    () => sessionStorage.getItem("langSel") || "eng"
  ); // default language
  const [memberId, setMemberId] = useState("");
  const [zip, setZip] = useState("");
  const [dateofbirth, setDateOfBirth] = useState("");
  const [exchangeType, setExchangeType] = useState("");
  const mainPaymentContentsRef = useRef(null);
  const formatAmount = (value) => {
    if (value !== null && value !== undefined) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
    return "0.00";
  };
  /* Setting userdata info in state */
  useEffect(() => {
    const userDataValue =
      process.env[carr_code] &&
      sessionStorage.getItem("userData_" + process.env[carr_code])
        ? JSON.parse(
            atob(sessionStorage.getItem("userData_" + process.env[carr_code]))
          )
        : "";
    // Only update userdata if the new value is different from the current state
    if (userDataValue !== "") {
      setUserData(userDataValue);
    }
  }, [carr_code]);

  useEffect(() => {
    const userValue = userdata ? userdata?.payment_info : "";
    if (userValue !== "") {
      setUser(userValue);
    }
  }, [carr_code, userdata]);

  const minimum_threshold_amt =
    paymentAmtThreshold?.minimum_amount_to_pay === "TOTAL_DUE_AMT"
      ? totalAmountDue
      : paymentAmtThreshold?.minimum_amount_to_pay;
  const maxAmount =
    /*minimum_threshold_amt > paymentAmtThreshold.maximum_amount_to_pay
        ? minimum_threshold_amt
        :*/ paymentAmtThreshold.maximum_amount_to_pay;

  useEffect(() => {
    if (cmsAllPages && cmsAllPages.makepayment) {
      setPaymentCMS(cmsAllPages.makepayment);
    }
  }, [cmsAllPages, setPaymentCMS]);

  //Toast notification
  useEffect(() => {
    if (notifyErr) {
      toast.error(notifyErr);
      setNotifyErr("");
    } else if (notifySuccess) {
      toast.success(notifySuccess);
      setNotifySuccess("");
    }
  }, [notifyErr, notifySuccess]);

  useEffect(() => {
    // Getpayment type(binder/recurring) from userdata
    if (user && user.caseInfo) {
      const paymentType = user.caseInfo[0].isBinderPayment
        ? "BINDER"
        : "ONETIME";
      setPaymentType(paymentType);
    } else {
      const paymentType = "";
      setPaymentType(paymentType);
    }
    const caseId =
      user && user.caseInfo[0].caseNum ? user.caseInfo[0].caseNum : "";
    setCaseId(caseId);
    const subscriberFirstName =
      user && user.caseInfo[0].firstName ? user.caseInfo[0].firstName : "";
    const subscriberLastName =
      user && user.caseInfo[0].lastName ? user.caseInfo[0].lastName : "";
    setSubscriberName(subscriberFirstName + " " + subscriberLastName);
    //In the case of binder payment, binderamount will be taken and otherwise, currentamoutn will be taken
    /* if (user.caseInfo[0].isBinderPayment) {
      const totalAmount =
        user && user.caseInfo[0].binderAmountDue
          ? Math.abs(user.caseInfo[0].binderAmountDue).toFixed(2)
          : "";
      setTotalAmountDue(totalAmount);
    } else {
      const totalAmount =
        user && user.caseInfo[0].currentAmountDue
          ? Math.abs(user.caseInfo[0].currentAmountDue).toFixed(2)
          : "";
      setTotalAmountDue(totalAmount);
    }*/

    const cim = user && user.caseInfo[0].cim ? user.caseInfo[0].cim : "";
    setCim(cim);
    //For casestatus api
    if (userdata) {
      // Only update state if the date has changed
      const zip = userdata.zip ? userdata.zip : "";
      setZip(zip);

      const member_id = userdata.login_id ? userdata.login_id : "";
      setMemberId(member_id);

      const dofbirth = userdata.dob ? userdata.dob : "";

      if (dofbirth !== "") {
        setDateOfBirth(dofbirth);
      }
    }
    const exchange_type =
      user && user.caseInfo[0].exchangeType
        ? user.caseInfo[0].exchangeType
        : "";
    setExchangeType(exchange_type);
  }, [user, userdata]);

  //Combine payload and headers for log API
  // Convert FormData to a plain JavaScript object
  function formDataToObject(formData) {
    const obj = {};
    formData.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }

  // Combine payload and headers
  const combinePayloadAndHeaders = useCallback((payload, headers) => {
    const payloadObject = formDataToObject(payload);

    // Combine payload and headers
    const combined = {
      payload: payloadObject,
      headers: headers,
    };

    return JSON.stringify(combined, null, 2); // Pretty print the JSON (optional)
  }, []);
  /* Get amount from case status api */

  useEffect(() => {
    // Ensure all required values are set and not empty or null
    if (dateofbirth && memberId && zip && carr_code) {
      const formatDate = (date) => {
        if (!date) return "";
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getUTCDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      const memberIdKey =
        memberId.length > 4 ? "carrierSubscriberId" : "last4OfSSN";
      const dobDate = dateofbirth ? formatDate(new Date(dateofbirth)) : "";
      const payload = new FormData();

      // Append your form fields to FormData
      payload.append("zip", zip);
      payload.append("dateOfBirth", dobDate); // Assuming dob is a string or formatted date
      payload.append([memberIdKey], memberId); // Assuming memberId is a string

      const guid = uuidv4();
      const carr_code_val = process.env[carr_code];
      const login_client_id = "REACT_APP_LOGIN_API_CLIENT_ID_" + carr_code_val;
      const login_client_secret =
        "REACT_APP_LOGIN_API_CLIENT_SECRET_" + carr_code_val;
      const headers = {
        "X-Hps-Trace-Id": guid,
        "X-Hps-Ts": Date.now(),
        "X-Hps-Carrier-Code": process.env[carr_code],
        "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
        "X-Hps-SiteCd": process.env[carr_code] + "GPT",
        "X-Hps-Client-Id": process.env[login_client_id],
        "X-Hps-Secret-Id": process.env[login_client_secret],
        "X-Hps-Db-Region": process.env.REACT_APP_REGION,
      };

      if (payload) {
        const request_to_log = combinePayloadAndHeaders(payload, headers);
        postData(
          process.env.REACT_APP_API_HTTP_URL + process.env.REACT_APP_API_PATH,
          process.env.REACT_APP_LOGIN_API_ENDPOINT,
          payload,
          headers
        )
          .then((result) => {
            if (result) {
              if (result.status && result.data && result.status === 200) {
                const response = result.data;

                if (!response.error) {
                  if (response.status_code === "HPS200") {
                    //API success
                    if (response.payment_info) {
                      //In the case of binder payment, binderamount will be taken and otherwise, currentamoutn will be taken
                      if (
                        response.payment_info &&
                        response.payment_info.caseInfo[0].isBinderPayment
                      ) {
                        const totalAmount = response.payment_info.caseInfo[0]
                          .binderAmountDue
                          ? parseFloat(
                              response.payment_info.caseInfo[0].binderAmountDue
                            )
                          : "";

                        const formattedTotalAmount = totalAmount
                          ? totalAmount < 0
                            ? "0.00"
                            : totalAmount.toFixed(2)
                          : "0.00";
                        setTotalAmountDue(formattedTotalAmount);
                      } else {
                        const totalAmount =
                          response.payment_info &&
                          response.payment_info.caseInfo[0].currentAmountDue
                            ? parseFloat(
                                response.payment_info.caseInfo[0]
                                  .currentAmountDue
                              )
                            : "";
                        const formattedTotalAmount = totalAmount
                          ? totalAmount < 0
                            ? "0.00"
                            : totalAmount.toFixed(2)
                          : "0.00";

                        setTotalAmountDue(formattedTotalAmount);
                      }
                      Log(
                        "Make Payment-Case status API",
                        "API",
                        response?.payment_info?.caseInfo[0]?.caseNum,
                        "API success. Got amount",
                        "INFO",
                        request_to_log,
                        result,
                        process.env.REACT_APP_API_HTTP_URL +
                          process.env.REACT_APP_API_PATH +
                          process.env.REACT_APP_LOGIN_API_ENDPOINT,
                        "S"
                      );
                    } else {
                      Log(
                        "Make Payment-Case status API",
                        "API",
                        "",
                        "API failure. Amount not retrieved.",
                        "ERROR",
                        request_to_log,
                        result,
                        process.env.REACT_APP_API_HTTP_URL +
                          process.env.REACT_APP_API_PATH +
                          process.env.REACT_APP_LOGIN_API_ENDPOINT,
                        "F"
                      );
                    }
                  } else {
                    //API not success
                    Log(
                      "Make Payment-Case status API",
                      "API",
                      "",
                      "API failure. Amount not retrieved.",
                      "ERROR",
                      request_to_log,
                      result,
                      process.env.REACT_APP_API_HTTP_URL +
                        process.env.REACT_APP_API_PATH +
                        process.env.REACT_APP_LOGIN_API_ENDPOINT,
                      "F"
                    );
                  }
                } else {
                  Log(
                    "Make Payment-Case status API",
                    "API",
                    "",
                    "API failure. Amount not retrieved.",
                    "ERROR",
                    request_to_log,
                    result,
                    process.env.REACT_APP_API_HTTP_URL +
                      process.env.REACT_APP_API_PATH +
                      process.env.REACT_APP_LOGIN_API_ENDPOINT,
                    "F"
                  );
                }
              } else {
                Log(
                  "Make Payment-Case status API",
                  "API",
                  "",
                  "API failure. Amount not retrieved.",
                  "ERROR",
                  request_to_log,
                  result,
                  process.env.REACT_APP_API_HTTP_URL +
                    process.env.REACT_APP_API_PATH +
                    process.env.REACT_APP_LOGIN_API_ENDPOINT,
                  "F"
                );
              }
            } else {
              Log(
                "Make Payment-Case status API",
                "API",
                "",
                "API failure. Result not retrieved.",
                "ERROR",
                request_to_log,
                result,
                process.env.REACT_APP_API_HTTP_URL +
                  process.env.REACT_APP_API_PATH +
                  process.env.REACT_APP_LOGIN_API_ENDPOINT,
                "F"
              );
            }
          })
          .catch((error) => {
            Log(
              "Make Payment-Case status API",
              "API",
              "",
              "Got exception: API failure. Amount not retrieved.",
              "ERROR",
              request_to_log,
              error,
              process.env.REACT_APP_API_HTTP_URL +
                process.env.REACT_APP_API_PATH +
                process.env.REACT_APP_LOGIN_API_ENDPOINT,
              "F"
            );
          })
          .finally(() => {});
      } else {
        Log(
          "Make Payment-Case status API",
          "API",
          "",
          "Got exception: API failure. Amount not retrieved.",
          "ERROR",
          headers,
          "Payload not set",
          process.env.REACT_APP_API_HTTP_URL +
            process.env.REACT_APP_API_PATH +
            process.env.REACT_APP_LOGIN_API_ENDPOINT,
          "F"
        );
      }
    }
  }, [
    dateofbirth,
    memberId,
    zip,
    carr_code,
    Log,
    combinePayloadAndHeaders,
  ]);
  //Get payment configuration by calling API
  useEffect(() => {
    // If carrier name is in url
    if (urlCarrier && paymentType) {
      const paymentConfigEndpoint =
        process.env.REACT_APP_PAYMENTCONFIG_API_ENDPOINT;
      // If payment config api endpoint is not null
      if (paymentConfigEndpoint) {
        const guid = uuidv4();
        const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
        const carr_code_val = process.env[carr_code];
        const pymt_config_client_id =
          "REACT_APP_PAYMENTCONFIG_API_CLIENT_ID_" + carr_code_val;
        const pymt_config_client_secret =
          "REACT_APP_PAYMENTCONFIG_CLIENT_SECRET_" + carr_code_val;
        const headers = {
          "X-Hps-Trace-Id": guid,
          "X-Hps-Ts": Date.now(),
          "X-Hps-Carrier-Code": process.env[carr_code],
          "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
          "X-Hps-SiteCd": process.env[carr_code] + "GPT",
          "Content-Type": "application/json",
          "X-Hps-Client-Id": process.env[pymt_config_client_id],
          "X-Hps-Secret-Id": process.env[pymt_config_client_secret],
          "X-Hps-Db-Region": process.env.REACT_APP_REGION,
        };

        getAPIData(
          // API call
          process.env.REACT_APP_API_HTTP_URL + process.env.REACT_APP_API_PATH,
          paymentConfigEndpoint,
          headers
        )
          .then((result) => {
            if (result.status && result.data && result.status === 200) {
              //If no AXIOS err
              const response = result.data;

              if (!response.error) {
                //If no API resp error
                if (response.status_code && response.status_code === "HPS200") {
                  //If API resp success
                  if (response.payment_configurations) {
                    Log(
                      "Make Payment-Payment Config API",
                      "API",
                      caseId,
                      "API success. Payment configuration retrieved.",
                      "INFO",
                      headers,
                      result,
                      paymentConfigEndpoint,
                      "S"
                    );
                    if (response.payment_configurations.payment_preferences) {
                      //Get Payment method preferences
                      const getpaymentPreferenceConfig = () => {
                        let binderPreference =
                          response.payment_configurations.payment_preferences.find(
                            (pref) => pref.context === paymentType
                          );
                        binderPreference = binderPreference
                          ? binderPreference
                          : response.payment_configurations.payment_preferences.find(
                              (pref) => pref.context === "DEFAULT"
                            );

                        if (binderPreference) {
                          return binderPreference;

                          // Return the entire object if context "binder" is found
                        } else {
                          return [];
                        }
                      };

                      setPaymentConfig(getpaymentPreferenceConfig());
                    } else {
                      Log(
                        "Make Payment-Payment Config API",
                        "API",
                        caseId,
                        "API success. Payment configuration preferences not retrieved.",
                        "ERROR",
                        headers,
                        result,
                        paymentConfigEndpoint,
                        "F"
                      );
                      // setNotifyErr("No Payment method found !");
                      // triggerToast("No Payment method found !", "error");
                    }
                    //Get Payment amount threshold
                    const pymt_amt_threshold = response.payment_configurations
                      .payment_amount_threshold
                      ? response.payment_configurations.payment_amount_threshold
                      : "";
                    setPaymentAmtThreshold(pymt_amt_threshold);
                  } else {
                    Log(
                      "Make Payment-Payment Config API",
                      "API",
                      caseId,
                      "API success. Payment configuration not retrieved.",
                      "ERROR",
                      headers,
                      result,
                      paymentConfigEndpoint,
                      "F"
                    );
                  }
                } else {
                  //If API resp not success
                  Log(
                    "Make Payment-Payment Config API",
                    "API",
                    caseId,
                    "API failure",
                    "ERROR",
                    headers,
                    result,
                    paymentConfigEndpoint,
                    "F"
                  );
                  const errCode = response.status_code
                    ? response.status_code
                    : "";
                  /* setNotifyErr(
                      errCode + " Technical error: No payment method set !"
                    );*/
                  /* triggerToast(
                      errCode + " Technical error: No payment method set !",
                      "error"
                    );*/
                }
              } else {
                //If API resp error
                Log(
                  "Make Payment-Payment Config API",
                  "API",
                  caseId,
                  "API failure. API response error.",
                  "ERROR",
                  headers,
                  result,
                  paymentConfigEndpoint,
                  "F"
                );
                //setNotifyErr("Technical error: No payment method set !");
                /* triggerToast(
                    "Technical error: No payment method set !",
                    "error"
                  );*/
              }
            } else {
              // API err
              Log(
                "Make Payment-Payment Config API",
                "API",
                caseId,
                "API failure. Response not retrieved.",
                "ERROR",
                headers,
                result,
                paymentConfigEndpoint,
                "F"
              );
              /* setNotifyErr(
                  result.status + " Technical error: No payment method set !"
                );*/
              /* triggerToast(
                  result.status + " Technical error: No payment method set !",
                  "error"
                );*/
            }
          })
          .catch((err) => {
            Log(
              "Make Payment-Payment Config API",
              "API",
              caseId,
              "Got Exception: API failure",
              "ERROR",
              headers,
              err,
              paymentConfigEndpoint,
              "F"
            );
            // setNotifyErr("Technical error: No payment method set !");
            //  triggerToast("Technical error: No payment method set !", "error");
          })

          .finally(() => {
            // Code that runs regardless of success or failure
            //  setLoading(false); //Hide loader
          });
      }
    } else {
      // console.log("No payment type got from user response!");
    }
  }, [urlCarrier, paymentType, Log, caseId]);

  /*useEffect(() => {
    if (notifyErr) {
      triggerToast(notifyErr, "error");
    }
    if (notifySuccess) {
      triggerToast(notifySuccess, "success");
    }
  }, [notifyErr, notifySuccess, triggerToast]);*/

  const payTotalAmount = () => {
    //event.preventDefault();
    //setradioOne(true);
    //setradioTwo(false);
    setShowOtherAmt(false);
    setShowtotalAmt(true);
  };
  const payOtherAmountCheck = () => {
    //event.preventDefault();
    // setradioOne(false);
    //setradioTwo(true);
    setShowOtherAmt(true);
    setShowtotalAmt(false);
  };
  // This function will be passed to PaymentMethodTab to change the error message
  const updatePayOtherAmtErr = (errorMessage) => {
    if (!showTotalAmt) {
      setPayOtherAmtErr(errorMessage);
    } else {
      setPayOtherAmtErr("");
    }
  };
  const updateTotalAmtDueErr = (errorMessage) => {
    if (!showOtherAmt) {
      setTotalAmtDueErr(errorMessage);
    } else {
      setTotalAmtDueErr("");
    }
  };
  //This is will remove pay other amt err when totalamount is checked
  useEffect(() => {
    if (showTotalAmt) {
      setPayOtherAmtErr("");
    }
    if (showOtherAmt) {
      setTotalAmtDueErr("");
    }
  }, [showTotalAmt, showOtherAmt]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mainPaymentContentsRef.current) {
        mainPaymentContentsRef.current.focus();
      }
    }, 2000); // Delay to ensure the DOM is fully rendered
    return () => clearTimeout(timer); // Cleanup the timer
  }, []);
  //Handle payotheramtchange
  const handlePayOtherAmt = (event) => {
    const otherAmt = event.target.value;
    setPayOtherAmount(otherAmt);
    // Check if the entered value is less than 50

    if (!otherAmt || parseFloat(otherAmt) < parseFloat(minimum_threshold_amt)) {
      setPayOtherAmtErr(
        cms.required_payment_amount_min +
          " " +
          "$" +
          minimum_threshold_amt +
          " " +
          cms.required_payment_amount_min_allowed
      );
    } else if (otherAmt && parseFloat(otherAmt) > maxAmount) {
      setPayOtherAmtErr(
        cms.required_payment_amount_max +
          " " +
          "$" +
          maxAmount +
          " " +
          cms.required_payment_amount_max_allowed
      );
    } else if(!/^\d*\.?\d*$/.test(otherAmt)){ //PMO0001745 phase 2
      setPayOtherAmtErr(
        cms?.required_payment_amount_min +
          " " +
          "$" +
          minimum_threshold_amt +
          " " +
          cms?.required_payment_amount_min_allowed
      );
    } else {
      setPayOtherAmtErr("");
    }
  };
  //Handle paytotalamtchange
  const handlePayTotalAmtdue = (totalAmountDue) => {
    // Check if the entered value is less than minimum amount or greater than maximum amount
    if (
      showTotalAmt &&
      parseFloat(totalAmountDue) < parseFloat(minimum_threshold_amt)
    ) {
      setTotalAmtDueErr(
        cms?.required_payment_amount_min +
          " " +
          "$" +
          minimum_threshold_amt +
          " " +
          cms?.required_payment_amount_min_allowed +
          " " +
          cms?.label_payother_amt_option
      );
      return "error";
    } else if (showTotalAmt && parseFloat(totalAmountDue) > maxAmount) {
      setTotalAmtDueErr(
        cms?.required_payment_amount_max +
          " " +
          "$" +
          maxAmount +
          " " +
          cms?.required_payment_amount_max_allowed +
          " " +
          cms?.label_payother_amt_option
      );
      return "error";
    } else {
      setTotalAmtDueErr("");
      return "";
    }
  };

  return (
    //payment content starts
      <div
          id="main-payment-contents"
          ref={mainPaymentContentsRef}
          tabIndex="-1"
      >
      <div id={`header-${urlCarrier}`}>
        <HeaderPayment
          page="makepayment"
          setLangSelected={setLangSelected}
        ></HeaderPayment>
      </div>
      <main id="main" className="main">
        <div>
          <Breadcrumbs cms={cms}></Breadcrumbs>
        </div>
        <div className="container-lg">
          <div className="payment px-4 mt-3 mb-5">
            <h2 className="heading2 pmt-page-title" tabIndex="0">{cms.label_pmt_title}</h2>
            <p tabIndex="0">{cms.label_pmt_description}.</p>
          </div>
          <div className="position-relative ms-1 px-3 ps-2 d-flex" id="caseid">
            <div className="col-xl-6 col-12 col-md-9 col-sm-12 d-xl-flex d-md-flex d-sm-flex d-flex position-absolute caseid-mobile-wrap">
              <div className="col-xl-4 col-md-4 col-sm-4 col-4 px-2 ps-0 caseid-box">
                <div className="bg-case text-center bg" tabIndex="0">
                  {cms.label_pmt_caseid}: {caseId}
                </div>
              </div>
              <div className="col-xl-8 col-md-7 col-sm-7 col-7 px-2 casename-box">
                <div className="bg-name text-center bg" tabIndex="0">
                  {cms.label_pmt_subscriber_name}: {subscriberName}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-3 d-sm-none d-none d-xl-block d-md-block" />
          </div>
          {/* Demo header*/}
          <section className="py-1 pb-3 bg-white">
            <div className="py-4 choose-pmt-wrap">
              <div className="content mt-4 px-3">
                <div className="col-12 d-flex choose-pmt-row">
                  <div className="col-6 mt-3">
                    <h4 className="fw-normal mt-2 payment" tabIndex="0">
                      {cms.label_pmt_choose_pymt_method}
                    </h4>
                  </div>
                  <div className="col-6 justify-content-end wallet-amount">
                    <div className="d-flex float-end"  tabIndex="0" aria-label={cms.label_pmt_total_amt_due + " $" + formatAmount(totalAmountDue)}>
                      <span className="wallet lh-xl me-3">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/icons/Payment/${urlCarrier}-wallet-card.svg`}
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop in case fallback also fails
                              e.target.src = `${process.env.PUBLIC_URL}/images/icons/Payment/Wallet-card.svg`;
                            }}
                          width={40}
                          height={40}
                          alt="Wallet-Amount"
                        />
                      </span>
                      <h4 className="mt-1">
                        {cms.label_pmt_total_amt_due}{" "}
                        <span className="mt-2 fw-semibold">
                          ${formatAmount(totalAmountDue)}
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <aside className="payement-mthd px-xl-5 px-md-3 px-sm-3 px-2 py-3 mx-3 pb-4">
              <form
                action=""
                method="post"
                className="needs-validation"
                noValidate=""
              >
                <div className="mb-2 mt-2">
                  <aside className="radio">
                    <div className="col-12 mb-4 top-section">
                      <div className="d-flex flex-wrap align-items-center gap-3 payment-options-row">

                        {/* Radio buttons group */}
                        <div className="d-flex align-items-center flex-wrap gap-3 flex-shrink-0 payment-radio-group">
                          <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="first_check"
                            className="me-2 flex-shrink-0"
                            name="group_1"
                            defaultValue="first"
                            onChange={payTotalAmount}
                            checked={showTotalAmt ? true : false}
                          />
                          <label htmlFor="first_check" className="mb-0">
                            {cms.label_pmt_pay_total_amt}
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="second_check"
                            className="me-2 flex-shrink-0"
                            name="group_1"
                            defaultValue="second"
                            onChange={payOtherAmountCheck}
                            checked={showOtherAmt ? true : false}
                          />
                          <label htmlFor="second_check" className="mb-0">
                            {cms.label_pmt_pay_other_amt}
                          </label>
                        </div>
                        </div>

                        {/* Dollar amount + Calendar date — always in the same row */}
                        <div className="d-flex align-items-start gap-3 flex-grow-1 payment-inputs-row">
                          <div style={{ minWidth: "130px", maxWidth: "220px"}}>
                          <article
                            id="first"
                            style={{
                              display: showTotalAmt ? "block " : "none",
                            }}
                          >
                            <div className="mb-2 border-bottom position-relative">
                              <span className="input-group-append">
                                <img
                                  src={
                                    urlCarrier === "bcbsaz"
                                        ? `${process.env.PUBLIC_URL}/images/icons/Payment/dollar-sign-bcbsaz.svg`
                                        : `${process.env.PUBLIC_URL}/images/icons/Payment/dollar-sign.svg`
                                  }
                                  className="me-2 position-absolute dollar-img start-0 bottom-0"
                                  alt="Dollar"
                                  width={17}
                                  height={17}
                                />
                              </span>
                              <input
                                type="text"
                                className="form-control totalamt_due"
                                name="totalamount"
                                id="totalamount"
                                placeholder={totalAmountDue}
                                value={formatAmount(totalAmountDue)}
                                readOnly
                                required
                              />
                            </div>
                            {totalAmtDueErr && (
                              <p id="payments-validation-error">
                                {totalAmtDueErr}
                              </p>
                            )}
                          </article>
                          <article
                            id="second"
                            style={{
                              display: showOtherAmt ? "block " : "none",
                            }}
                          >
                            <div className="mb-2 border-bottom position-relative">
                              <span className="input-group-append">
                                <img
                                  src={
                                      urlCarrier === "bcbsaz"
                                        ? `${process.env.PUBLIC_URL}/images/icons/Payment/dollar-sign-bcbsaz.svg`
                                        : `${process.env.PUBLIC_URL}/images/icons/Payment/dollar-sign.svg`
                                    }
                                  className="me-2 position-absolute dollar-img start-0 bottom-0"
                                  alt="Dollar"
                                  width={17}
                                  height={17}
                                />
                              </span>
                              <input
                                type="text"
                                className="form-control other_amt_inp"
                                name="otheramount"
                                id="otheramount"
                                placeholder="0.00"
                                value={payOtherAmount}
                                onChange={handlePayOtherAmt}
                                required
                                min={minimum_threshold_amt}
                                max={maxAmount}
                              />
                            </div>
                            {payOtherAmtErr && (
                                <p id="payments-validation-error">
                                {payOtherAmtErr}
                              </p>
                            )}
                          </article>
                        </div>

                      <div style={{ minWidth: "130px", maxWidth: "220px"}}>
                        <div className="mb-2 border-bottom position-relative">
                          <span className="input-group-append">
                            <img
                              src={
                                    urlCarrier === "bcbsaz"
                                      ? `${process.env.PUBLIC_URL}/images/icons/calendar-bcbsaz.svg`
                                      : `${process.env.PUBLIC_URL}/images/icons/calendar.svg`
                                  }
                              className="me-2 position-absolute start-0 bottom-0"
                              alt="Calendar"
                              width={17}
                              height={17}
                            />
                          </span>
                          <input
                            type="text"
                            className="form-control payment_date"
                            id="PaymentDate"
                            value={date.toLocaleDateString("en-US", {
                              month: "2-digit",
                              day: "2-digit",
                              year: "numeric",
                            })}
                            readOnly
                          />
                        </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </aside>
                </div>
                {/*Payment Type Button*/}

                {/*  {paymentConfig.map((paymentConfigAr, paymentType) => (
                      <button
                        className={
                          "nav-link mb-3 " + (showCCD ? "active" : " ")
                        }
                        id="v-pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-home"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-home"
                        aria-selected={showCCD ? "true " : "false"}
                        onClick={toggleCCD}
                      >
                        <span className="d-block mb-1">Card</span>
                        <i className="fe fe-wallet-r" />
                      </button>
                    ))}*/}

                <PaymentMethodTab
                  paymentConfig={paymentConfig}
                  urlCarrier={urlCarrier}
                  // triggerToast={triggerToast}
                  paymentType={paymentType}
                  payOtherAmount={payOtherAmount}
                  payOtherAmtErr={payOtherAmtErr}
                  updatePayOtherAmtErr={updatePayOtherAmtErr}
                  showTotalAmt={showTotalAmt}
                  totalAmountDue={totalAmountDue}
                  cim={cim}
                  cms={cms}
                  setNotifyErr={setNotifyErr}
                  setNotifySuccess={setNotifySuccess}
                  updateTotalAmtDueErr={updateTotalAmtDueErr}
                  langSelected={langSelected}
                  showOtherAmt={showOtherAmt}
                  handlePayTotalAmtdue={handlePayTotalAmtdue}
                  caseNum={caseId}
                  hixIndicator={exchangeType}
                  contactName={subscriberName}
                ></PaymentMethodTab>
              </form>
              {/* <Toast
                message={toastMessage}
                showToast={showToast}
                closeToast={() => setShowToast(false)}
                type={toastType}
              />*/}
              <ToastContainer></ToastContainer>
            </aside>
          </section>
        </div>
      </main>
      <BackToTopButton></BackToTopButton>

      <Footer cms={cms}></Footer>
    </div>
    //payment content ends
  );
}
